import { ChurnSignal } from '@/models/DashboardData';

/** Same shape as Overview / Signals pages — `signals.recent` or legacy `churnSignals`. */
export function extractChurnSignalsFromDashboard(dashboardData: unknown): ChurnSignal[] {
  const d = dashboardData as Record<string, unknown> | undefined | null;
  if (!d) return [];
  const recent = (d as { signals?: { recent?: ChurnSignal[] } }).signals?.recent;
  if (Array.isArray(recent)) return recent;
  const legacy = (d as { churnSignals?: ChurnSignal[] }).churnSignals;
  if (Array.isArray(legacy)) return legacy;
  return [];
}

/**
 * Match dashboard signals to a member. Prefer `userId` (audience member id from API) and fall back to email
 * (stable when `userId` was wrongly set to the actor before the API fix).
 */
export function filterSignalsForMember(
  signals: ChurnSignal[],
  memberId: string | undefined,
  memberEmail: string | undefined,
): ChurnSignal[] {
  const id = memberId?.trim();
  const emailNorm = memberEmail?.trim().toLowerCase();
  if (!id && !emailNorm) return [];

  return signals.filter((s) => {
    const sid = (s.userId || '').trim();
    if (id && sid === id) return true;
    const em = (s.userEmail || '').trim().toLowerCase();
    if (emailNorm && em === emailNorm) return true;
    return false;
  });
}
